module.exports = __webpack_public_path__ + "img/MinusIcon.aa991cd6.svg";